// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__BX3b8","heroRow":"Hero_heroRow__EQHVD","heroSlide":"Hero_heroSlide__fmu7q","slideBackground":"Hero_slideBackground__g-mmV"};